import { withTheme } from '../config';
import { Header } from '@rneui/base/dist/Header/Header';
export { Header };
export default withTheme(Header, 'Header');
